module.exports = __webpack_public_path__ + "static/img/8.1ad2676.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/8.png
// module id = 31s2
// module chunks = 0